import { createAction, props } from '@ngrx/store';
import { Feature } from './features.reducer';

export const getFeatures = createAction('[Features] Get features');
export const getFeaturesComplete = createAction('[Features] Get features loaded', props<{ features: Feature[] }>());
